import { cn } from '@/utils/cn'

interface OnboardingProgressProps {
  currentStep: number
  totalSteps: number
}

export function OnboardingProgress({ currentStep, totalSteps }: OnboardingProgressProps) {
  return (
    <div className="flex items-center gap-2">
      {Array.from({ length: totalSteps }, (_, i) => (
        <div
          key={i}
          className={cn(
            'h-1.5 rounded-full flex-1 transition-colors duration-300',
            i < currentStep ? 'bg-framed-neutral-800' : 'bg-framed-neutral-300'
          )}
        />
      ))}
    </div>
  )
}
